import type { ComponentProps } from 'react';
import { clsx } from 'clsx';
import { Field, type FieldProps } from './Field';
import { controlClassName, fieldHintId } from './fieldParts';

type SelectFieldProps = ComponentProps<'select'> & Omit<FieldProps, 'children'>;

/** Liste déroulante libellée (options en enfants, ex. <ReferenceOptions>) */
export function SelectField({
  id,
  label,
  hint,
  required,
  error,
  className,
  children,
  ...selectProps
}: SelectFieldProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} required={required}>
      <select
        id={id}
        className={clsx(controlClassName, 'h-9', className)}
        aria-invalid={!!error}
        aria-required={required || undefined}
        aria-describedby={hint ? fieldHintId(id) : undefined}
        {...selectProps}
      >
        {children}
      </select>
    </Field>
  );
}
